import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import CreatePartRequestForm from "../../components/partRequests/CreatePartRequestForm";
import Card from "../../components/shared/Card/Card";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import usePartRequests from "../../data/usePartRequests";

export default function CreatePartRequest() {
  const navigate = useNavigate();
  const { setInfo } = usePageNameContext();
  const { create } = usePartRequests();

  useEffect(() => {
    setInfo({
      name: "Log a Part Request",
      desc: "A caller wants a part you don't have in stock - log it so it can be matched against vehicles coming in, or sent to the PartPro network.",
    });
  }, []);

  return (
    <Card containerClassName="mt-4">
      <CreatePartRequestForm
        isLoading={create.isLoading}
        onCancel={() => navigate("/part-requests")}
        onSubmit={(request) =>
          create.mutate(request, {
            onSuccess: (response) => {
              navigate(response?.data?.id ? `/part-requests/${response.data.id}` : "/part-requests");
            },
          })
        }
      />
    </Card>
  );
}
